import React from 'react';
import PreconSupporterFooter from './PreconSupporterFooter';
import { PageProps as GatsbyPageProps } from 'gatsby';
import { ServiceProvider } from '@/di/precon-supporter';
import { DebugModeProvider } from '@/hooks/precon-supporter';
import { DebugTool } from '@/components/precon-supporter/debug/DebugTool';
import { InAppBrowserWarningDialog } from '@/components/precon-supporter/shared/InAppBrowserWarningDialog';

import * as styles from './PreconSupporterPage.module.css';

type PreconSupporterPageProps = {
  element: React.ReactNode;
  props: GatsbyPageProps;
};

const PreconSupporterPage: React.FC<PreconSupporterPageProps> = ({
  element,
  props,
}) => {
  const courseId: 'basic' | 'advanced' = props.location.pathname.includes(
    '/advanced/'
  )
    ? 'advanced'
    : 'basic';

  return (
    <DebugModeProvider>
      <ServiceProvider>
        <div className={styles.container}>
          <div>{element}</div>
          <PreconSupporterFooter courseId={courseId} />
        </div>
        <InAppBrowserWarningDialog />
        <DebugTool />
      </ServiceProvider>
    </DebugModeProvider>
  );
};

export default PreconSupporterPage;
